import type { IconName } from '../components/Icon'

export interface ComingSoonContent {
  title: string
  icon: IconName
  summary: string
  bullets: string[]
  dependency?: string
}

// Route path → placeholder content. Each becomes a real route in the Shell so
// deep links, nav highlighting and later replacement are trivial.
export const COMING_SOON: Record<string, ComingSoonContent> = {
  '/sandbox': {
    title: 'Sandbox',
    icon: 'box',
    summary:
      'An isolated execution environment for code-execution mode: run agent-written code next to your tools without touching production data.',
    bullets: [
      'Ephemeral, network-restricted runtimes',
      'Mount tool results as files',
      'Resource and time limits per run',
    ],
  },
}
